import React, {useState} from 'react';
import Modal from '../../../../../components-new/ui/Modal';
import {addUserToBlackList} from '../../../../../services/company/api';
import {addNotification as addNotificationAction} from "../../../../../services/notification/action";
import {connect} from "react-redux";
import {generalModalStyles} from "../../../../../utils/General";
import Input from "../../../../../components-new/form/Input";
import Translate from "../../../../../components/Translate";
import SilverButton from "../../../../../components-new/buttons/SilverButton";
import DestructiveButton from "../../../../../components-new/buttons/DestructiveButton";
import config from "../../../../../config";
import PersonOffIcon from "../../../../../assets/icons/PersonOffIcon";
import './ChatActionModals.css';

const BlockUserModal = ({isOpen, cancelAction, conversation, addNotification}) => {
    const [subject, setSubject] = useState('');
    const [description, setDescription] = useState('');

    const addToBlackList = () => {
        const entity = {
            subject,
            description,
            userId: conversation.userId,
            companyId: conversation.companyId,
            platform: conversation.platform,
        };

        addUserToBlackList(entity, conversation.companyId, conversation.id)
            .then(d => {
                if (d.status === 226) {
                    addNotification('userAlreadyInBlackList', config.notificationLevels.warning);
                } else if (d.status === 200) {
                    addNotification('userAddedInBlackList', config.notificationLevels.info);
                }
            })
            .catch(() => {
                addNotification('somethingWentWrong', config.notificationLevels.error);
            });

        cancelAction();
    };

    return (
        <Modal isOpen={isOpen} style={generalModalStyles.convHeaderModalStyles}
               onRequestClose={cancelAction}
               title={<Translate text="blockUser"/>}
               description={<Translate text="blockUserInfo"/>}
               headerIcon={<PersonOffIcon width={20} height={20} fill="var(--ds-error-primary)"/>}
               headerSeparator
               footerSeparator
               footer={<React.Fragment>
                   <SilverButton type="button" width="auto" height="40px" onClick={cancelAction}>
                       <Translate text="close"/>
                   </SilverButton>
                   <DestructiveButton type="button" width="auto" height="40px" onClick={addToBlackList}>
                       <Translate text="blockAndEnd"/>
                   </DestructiveButton>
               </React.Fragment>}>
            <div className="chat-action-modal__body">
                <Input
                    label={<Translate text="reason"/>}
                    style={{height: '40px'}}
                    value={subject}
                    onChange={e => setSubject(e.target.value)}
                />
                <Input
                    label={<Translate text="description"/>}
                    resize={'none'}
                    isTextarea
                    value={description}
                    onChange={e => setDescription(e.target.value)}
                    style={{minHeight: '200px'}}
                />
            </div>

        </Modal>
    );
};

const mapDispatchToProps = dispatch => ({
    addNotification: (message, level, config) => {
        dispatch(addNotificationAction(message, level, config));
    },
});

export default connect(null, mapDispatchToProps)(BlockUserModal);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/chat/chat-components/BlockUserModal.jsx